import { Pipe, PipeTransform } from '@angular/core';
import { Section, SectionKey } from '../models/search-edition-params';

@Pipe({
  name: 'searchSectionLabel'
})
export class SearchSectionLabelPipe implements PipeTransform {

    /* Get search section label by key */
    transform(sections: Array<Section>, key: SectionKey): string {
        const sectionFound = sections.find(function (section) {
            return section.key === key;
        });
        if (sectionFound) {
            return sectionFound.label;
        } else {
            return '<label not found for \'' + key + '\' key>';
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/pipes/search-section-label.pipe.ts